import type { Save } from './save/schema';

/**
 * The full game (docs/MONETIZATION.md, owner 2026-10-06): free to start, one purchase unlocks the
 * rest. Free: campaign lawns up to FREE_LAWNS (the Backyard and its boss), the Daily, Endless and
 * shared lawns. The purchase itself lives in the platform layer; the save mirrors it.
 */
export const FREE_LAWNS = 20;

/** The thank-you cosmetic that comes with the full game. */
export const THANK_YOU_COSMETIC = 'paint-thanks';

/**
 * Whether a mower comes with the full game (owner, 2026-10-07): one unlocked by the Backyard boss
 * or later (the Lawn Tractor on) waits for it, rather than opening with nothing left to mow.
 */
export const mowerNeedsFullGame = (unlockLevel: number): boolean => unlockLevel >= FREE_LAWNS;

/** Whether campaign lawn `n` needs the full game (and this save does not have it). */
export function needsFullGame(save: Readonly<Save>, n: number): boolean {
  return n > FREE_LAWNS && !save.fullGame;
}

/** The full game is unlocked: every lawn opens, and the thank-you paint is the player's. */
export function grantFullGame(save: Save): void {
  save.fullGame = true;
  if (!save.cosmetics.owned.includes(THANK_YOU_COSMETIC)) {
    save.cosmetics.owned.push(THANK_YOU_COSMETIC);
  }
}
